import { TipoDeModalAcoesDocumento, TipoDeSecaoAcoesDocumento } from '@/enums'
import type { Rota } from '@/models'

export const CADASTROS_ROTAS = {
  integracao: '/app/cadastros/configuracoes-papel-zero',
}

export const DOCUMENTO_ROTAS = {
  documento: (id: string) => `/app/documento/${id}`,
  baixar: (id: string) => `/app/documento/${id}/baixar`,
  assinar: (id: string) => `/app/documento/${id}/assinar`,
  compartilhar: (id: string) => `/app/documento/${id}/compartilhar`,
  historico: (id: string) => `/app/documento/${id}/historico`,
}

export const obterRotaDeMenuItemCadastros = (
  integracaoPapelZeroHabilitada: boolean,
  parametrizar?: boolean
) => {
  if (!integracaoPapelZeroHabilitada) return null
  if (parametrizar) return CADASTROS_ROTAS.integracao
  return null
}

const rotaCadastros: Rota = {
  path: 'cadastros',
  permissoes: ['permissao_para_parametrizar_campos_da_integracao'],
  filhas: [
    { index: true, pagina: 'Cadastros', titulo: 'Cadastros' },
    {
      path: 'configuracoes-papel-zero',
      pagina: 'Cadastros/pages/DadosParaEnvioAoPapelZero',
      titulo: 'Dados para envio ao Papel Zero',
    },
  ],
}

export function obterRotas(integracaoPapelZeroHabilitada: boolean): Rota[] {
  return [
    { path: '/', pagina: 'Home' },
    {
      path: '/publico',
      filhas: [
        { index: true, redirecionarPara: 'documentos' },
        {
          path: 'documentos',
          pagina: 'ConsultarDocumentosPublicos',
          titulo: 'Consulta de documento público',
        },
        {
          layout: 'publico',
          filhas: [
            {
              path: 'documentos/:token',
              pagina: 'Documento',
              titulo: 'Consulta Pública',
              props: { publico: true },
            },
          ],
        },
      ],
    },
    {
      path: '/app',
      layout: 'app',
      filhas: [
        { index: true, redirecionarPara: 'documentos' },
        { path: 'documentos', pagina: 'Documentos', titulo: 'Documentos' },
        { path: 'documento/:id', pagina: 'Documento' },
        {
          path: 'documento/:id/baixar',
          pagina: 'Documento',
          props: { secaoInicial: TipoDeSecaoAcoesDocumento.BAIXAR },
        },
        {
          path: 'documento/:id/assinar',
          pagina: 'Documento',
          props: { secaoInicial: TipoDeSecaoAcoesDocumento.ASSINAR },
        },
        {
          path: 'documento/:id/compartilhar',
          pagina: 'Documento',
          props: { modalInicial: TipoDeModalAcoesDocumento.COMPARTILHAR },
        },
        {
          path: 'documento/:id/historico',
          pagina: 'Documento',
          props: { modalInicial: TipoDeModalAcoesDocumento.HISTORICO },
        },
        {
          path: 'configuracoes',
          permissoes: ['admin'],
          filhas: [
            { index: true, pagina: 'Configuracoes', titulo: 'Configurações' },
            {
              path: 'grupos',
              pagina: 'Configuracoes/pages/Grupos',
              titulo: 'Grupos',
            },
          ],
        },
        ...(integracaoPapelZeroHabilitada ? [rotaCadastros] : []),
      ],
    },
  ]
}
